import { Component, Element, Event, EventEmitter, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'biel-button',
  styleUrl: 'biel-button.css',
  shadow: true,
})
export class BielButton {

  bielBot: any;
  @Element() el: HTMLElement;
  @Prop() customFont: boolean = false;
  @Prop() project: string = '';
  @Prop() buttonStyle: string = 'default';
  @Prop() buttonPosition: string = 'default';
  @Prop() modalPosition: string = 'center';
  @Prop() email: string = '';
  @Prop() headerTitle: string = 'Company Name AI';
  @Prop() inputPlaceholderText: string = 'Type your message';
  @Prop() sendButtonText: string = 'Send';
  @Prop() hideIcon: boolean = false;
  @Prop() hideExpandButton: boolean = false;
  @Prop() expandModal: boolean = false;
  @Prop() errorMessage404: string = "Oops! We could not find the provided project ID.";
  @Prop() errorMessage403: string = "Oops! The request URL does not match the one defined for this project.";
  @Prop() errorMessageDefault: string = "Oops! Please try again later.";
  @Prop() footerText: string = "AI-generated answers may contain errors. Verify official sources before use.";
  @Prop() suggestedQuestionsTitle: string = 'Suggested questions';
  @Prop() initialMessages: { text: string, sender: 'user' | 'ai', feedback?: 0 | 1 }[] = [];
  @Prop() disableInput: boolean = false;
  @Prop() hideFeedback: boolean = false;
  @Prop() bielId: string = `biel-bot-${Math.random().toString(36).substring(2, 9)}`;
  @Prop() showTermsModal: boolean = false;
  @Prop() termsTitle: string = "Chatbot Terms & Conditions";
  @Prop() termsDescription: string = "Please review our <a href='https://biel.ai/terms' target='_blank' rel='noopener'>Terms & Conditions</a> before proceeding.";
  @Prop() termsCheckboxText: string = "I have read and agree to the Terms & Conditions.";
  @Prop() sourcesText: string = 'Sources';
  @Prop() suggestedQuestions: string = '';
  @Prop() welcomeMessage: string = '';

  @Event() bielBotButtonClick: EventEmitter<void>;
  @Event() termsDeclined: EventEmitter<boolean>;

  connectedCallback() {
    this.bielBot = document.createElement('biel-bot');
    const props = [
      'customFont',
      'project',
      'modalPosition',
      'email',
      'headerTitle',
      'inputPlaceholderText',
      'sendButtonText',
      'hideIcon',
      'hideExpandButton',
      'expandModal',
      'errorMessage404',
      'errorMessage403',
      'errorMessageDefault',
      'footerText',
      'suggestedQuestionsTitle',
      'initialMessages',
      'disableInput',
      'hideFeedback',
      'bielId',
      'showTermsModal',
      'termsTitle',
      'termsDescription',
      'termsCheckboxText',
      'sourcesText',
      'suggestedQuestions',
      'welcomeMessage'
    ];

    props.forEach(prop => {
      this.bielBot[prop] = this[prop];
    });

    document.body.appendChild(this.bielBot);
  }

  disconnectedCallback() {
    document.body.removeChild(this.bielBot);
  }

  isSafariBrowser() {
    const isSafari = /safari/i.test(navigator.userAgent) && !/chrome/i.test(navigator.userAgent);
    return isSafari;
  }

  componentDidLoad() {
    const buttonContent = this.el.shadowRoot.querySelector('.biel-button-content') as HTMLElement;
    if (this.buttonPosition === 'center-right') {
      let adjustment = 0;
      if (this.isSafariBrowser()) {
        adjustment = 10;
      }
      buttonContent.style.right = `${(buttonContent.offsetWidth + adjustment) / 2 * -1}px`;
    }
    if (!this.customFont) {
      this.loadInterFont();
    }
  }

  loadInterFont() {
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }

  showModal() {
    this.bielBot.showModal = true;
    this.bielBotButtonClick.emit();
    this.termsDeclined.emit(false);
  }

  render() {
    return (
      <Host>
        <a class={`biel-button-content biel-button-content--${this.buttonStyle} biel-button-content--${this.buttonPosition}`} onClick={() => this.showModal()}>
          {!this.hideIcon && (
            <span class="biel-button-content-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-bot"><path d="M12 8V4H8"/><rect width="16" height="12" x="4" y="8" rx="2"/><path d="M2 14h2"/><path d="M20 14h2"/><path d="M15 13v2"/><path d="M9 13v2"/></svg>
            </span>
          )}
          <slot />
        </a>
      </Host>
    );
  }
}